class ImageCarousel extends HTMLElement {
  constructor() {
    super();
    this.carousel = null;
    this.elements = {
      carousel: this.querySelector(".splide"),
    };
  }

  connectedCallback() {
    this.initCarousel();
  }

  initCarousel() {
    const Splide = window.Splide;

    if (!Splide) return;

    this.carousel = new Splide(this.elements.carousel, {
      type: "loop",
      perPage: this.getAttribute("data-slides-to-show"),
      gap: parseInt(this.getAttribute("data-slides-gap")),
      pagination: this.getAttribute("data-enable-pagination") == "true",
      arrows: this.getAttribute("data-enable-arrows") == "true",
      breakpoints: {
        1200: {
          perPage: this.getAttribute("data-slides-to-show-tablet"),
        },
        768: {
          perPage: this.getAttribute("data-slides-to-show-mobile"),
          padding: { right: "5rem" },
        },
      },
    }).mount();
  }
}

if (!customElements.get("image-carousel")) {
  customElements.define("image-carousel", ImageCarousel);
}
